"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteHeaderGap = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = require("react-redux");

var _components = require("components");

var _SiteHeader = require("@quixeltools/quixel-ui-library/dist/components/common/website/SiteHeader");

var _SiteHeader2 = _interopRequireDefault(_SiteHeader);

var _auth = require("redux/modules/auth");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var product = function product(image) {
  return "" + image;
};

var cloudfrontIcons = function cloudfrontIcons(path) {
  return "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/" + path;
};

var SiteHeaderContainer = function (_React$Component) {
  (0, _inherits3.default)(SiteHeaderContainer, _React$Component);

  function SiteHeaderContainer(props) {
    (0, _classCallCheck3.default)(this, SiteHeaderContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SiteHeaderContainer.__proto__ || (0, _getPrototypeOf2.default)(SiteHeaderContainer)).call(this, props));

    _this.logout = _this.logout.bind(_this);

    _this.toggleDropdown = _this.toggleDropdown.bind(_this);

    var forumBaseUrl = (0, _utils.getFormBaseUrl)();
    var menuLinks = [{
      label: "SUBSCRIBE",
      to: "/pricing",
      isButton: true,
      mobileOnly: true
      // img: `${product('https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/bridge_icon_2048_preview.png')}`
    }, {
      label: "PRODUCTS",
      onMouseOver: function onMouseOver() {
        return _this.toggleDropdown(true, "PRODUCTS");
      },
      onMouseOut: function onMouseOut() {
        return _this.toggleDropdown(false, "PRODUCTS");
      },
      isOpen: false,
      submenu: [{
        label: "Megascans",
        to: "/megascans",
        img: "" + product("https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/megascans_icon_2048_preview.png"),
        submenu: [{
          label: "Browse Megascans",
          to: "/megascans/library",
          // onClick:()=>(__CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':''),
          icon: true
        }]
      }, {
        label: "BRIDGE",
        to: "/bridge",
        img: "" + product("https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/bridge_icon_2048_preview.png")
      }, {
        label: "MIXER",
        to: "/mixer",
        img: "" + product("https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/mixer_icon_2048_preview.png")
      }]
    }, {
      label: "COMPANY",
      onMouseOver: function onMouseOver() {
        return _this.toggleDropdown(true, "COMPANY");
      },
      onMouseOut: function onMouseOut() {
        return _this.toggleDropdown(false, "COMPANY");
      },
      isOpen: false,
      submenu: [{
        label: "Blog",
        to: "/blog"
      }, {
        label: "Jobs",
        to: "/jobs"
      }, {
        label: "About",
        to: "/about"
      }]
      // img: `${product('https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/megascans_icon_2048_preview.png')}`
    }, {
      label: "LEARNING",
      onMouseOver: function onMouseOver() {
        return _this.toggleDropdown(true, "LEARNING");
      },
      onMouseOut: function onMouseOut() {
        return _this.toggleDropdown(false, "LEARNING");
      },
      isOpen: false,
      submenu: [{
        label: "Educational Program",
        to: "/education"
      }, {
        label: "Tutorials",
        href: "https://www.youtube.com/channel/UCNTZFGRsyqNtvI4T2syNkIw",
        newWindow: true
      }, {
        label: "Get Help",
        to: forumBaseUrl + "/hc/en-us/requests/new",
        newWindow: true
      }, {
        label: "FAQ",
        href: forumBaseUrl,
        newWindow: true
      }]
    }, {
      label: "COMMUNITY",
      onMouseOver: function onMouseOver() {
        return _this.toggleDropdown(true, "COMMUNITY");
      },
      onMouseOut: function onMouseOut() {
        return _this.toggleDropdown(false, "COMMUNITY");
      },
      isOpen: false,
      submenu: [{
        label: "Community Gallery",
        to: "/gallery"
      }, {
        label: "Facebook Group",
        to: "https://www.facebook.com/groups/QuixelToolsGroup",
        newWindow: true
      }, {
        label: "Forum",
        to: forumBaseUrl + "/hc/en-us/community/topics",
        newWindow: true
      }]
      // img: `${product('https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/megascans_icon_2048_preview.png')}`
    }];

    _this.state = { menuLinks: menuLinks };
    return _this;
  }

  (0, _createClass3.default)(SiteHeaderContainer, [{
    key: "logout",
    value: function logout() {
      return this.props.logout();
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(open, key) {
      var menuLinks = this.state.menuLinks;

      var menuItem = menuLinks.find(function (m) {
        return m.label == key;
      });
      if (menuItem) {
        menuItem.isOpen = open;
      }
      this.setState({ menuLinks: menuLinks });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var menuLinks = this.state.menuLinks;

      var loginIndex = _ramda2.default.findIndex(_ramda2.default.propEq("label", "SIGN IN"))(menuLinks);
      var logoutIndex = _ramda2.default.findIndex(_ramda2.default.propEq("label", "SIGN OUT"))(menuLinks);
      if (this.props.loggedIn) {
        if (loginIndex !== -1) {
          menuLinks = _ramda2.default.remove(loginIndex, 1, menuLinks);
        }
        if (logoutIndex === -1) {
          menuLinks.push({
            label: "SIGN OUT",
            mobileOnly: true,
            onClick: this.logout
            // img: `${product('https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/mixer_icon_2048_preview.png')}`
          });
        }
      } else {
        if (loginIndex === -1) {
          menuLinks.push({
            label: "SIGN IN",
            to: { pathname: "/login", state: { modal: true } }
          });
        }
        if (logoutIndex !== -1) {
          menuLinks = _ramda2.default.remove(logoutIndex, 1, menuLinks);
        }
      }

      return _react2.default.createElement(_SiteHeader2.default, {
        logoTo: "/",
        logoAlt: "Quixel logo",
        logoUrl: cloudfrontIcons("quixelHeader.png"),
        logoSmallUrl: cloudfrontIcons("quixel_logo_small.png"),
        links: menuLinks,
        location: this.props.location,
        dropdown: false,
        menu: _react2.default.createElement(_components.SiteHeaderMenu, null),
        setDropdown: function setDropdown() {
          menuLinks.map(function (m) {
            if (m.isOpen) {
              m.isOpen = false;
            }
          });
          _this2.setState({ menuLinks: menuLinks });
        }
      });
    }
  }]);
  return SiteHeaderContainer;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn
  };
}, { logout: _auth.logout })(SiteHeaderContainer);
var SiteHeaderGap = exports.SiteHeaderGap = function SiteHeaderGap() {
  return _react2.default.createElement("div", { className: require("./SiteHeader.scss").SiteHeaderGap });
};


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteHeader/SiteHeader.jsx
// module id = 2391
// module chunks = 0